var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-comp" },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.table.showSearchBar,
              expression: "table.showSearchBar",
            },
          ],
          ref: "queryForm",
          attrs: { inline: true, model: _vm.table.defaultParams },
        },
        [
          _vm._l(_vm.table.searchOptions, function (option, opIndex) {
            return opIndex < _vm.minNum
              ? _c(
                  "el-form-item",
                  { key: opIndex, attrs: { label: option.label } },
                  [
                    option.type === "dict"
                      ? _c(
                          "el-select",
                          {
                            staticClass: "handle-select",
                            staticStyle: { width: "225px" },
                            attrs: {
                              clearable: "",
                              filterable: "",
                              multiple: option.multiple,
                              placeholder: option.placeholder,
                              size: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.searchSelectFn(option)
                              },
                            },
                            model: {
                              value: option.value,
                              callback: function ($$v) {
                                _vm.$set(option, "value", $$v)
                              },
                              expression: "option.value",
                            },
                          },
                          _vm._l(
                            _vm.dictData[option.dictKey],
                            function (selectOption, i) {
                              return _c("el-option", {
                                key: i,
                                attrs: {
                                  label: selectOption.desc,
                                  value: selectOption.code,
                                },
                              })
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                    option.type === "select"
                      ? _c(
                          "el-select",
                          {
                            staticClass: "handle-select",
                            staticStyle: { width: "225px" },
                            attrs: {
                              clearable: "",
                              filterable: "",
                              multiple: option.multiple,
                              placeholder: option.placeholder,
                              size: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.searchSelectFn(option)
                              },
                            },
                            model: {
                              value: option.value,
                              callback: function ($$v) {
                                _vm.$set(option, "value", $$v)
                              },
                              expression: "option.value",
                            },
                          },
                          _vm._l(option.options, function (selectOption) {
                            return _c("el-option", {
                              key: selectOption.key,
                              attrs: {
                                label: selectOption.label,
                                value: selectOption.id,
                              },
                            })
                          }),
                          1
                        )
                      : _vm._e(),
                    option.type === "cascader"
                      ? _c("el-cascader", {
                          staticStyle: { width: "225px" },
                          attrs: {
                            size: "small",
                            filterable: "",
                            "show-all-levels": option.showAllLevels,
                            props: {
                              checkStrictly: option.props.checkStrictly,
                              multiple: option.props.multiple,
                              value: option.props.value
                                ? option.props.value
                                : "ID",
                              children: option.props.children
                                ? option.props.children
                                : "children",
                              label: option.props.label
                                ? option.props.label
                                : "label",
                            },
                            options: option.options,
                            placeholder: "全部",
                            clearable: "",
                          },
                          on: { change: _vm.searchSelectFn },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "cascader2"
                      ? _c("el-cascader", {
                          ref: "cascader2",
                          refInFor: true,
                          staticStyle: { width: "225px" },
                          attrs: {
                            size: "small",
                            filterable: "",
                            "show-all-levels": option.showAllLevels,
                            props: {
                              lazy: true,
                              lazyLoad: _vm.loadNode,
                              checkStrictly: false,
                              multiple: option.props.multiple,
                              value: "productCategoryId",
                              label: "categoryName",
                              children: "children",
                            },
                            options: option.options,
                            placeholder: "全部",
                            clearable: "",
                          },
                          on: { change: _vm.searchSelectFn },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "city"
                      ? _c("el-cascader", {
                          staticStyle: { width: "225px" },
                          attrs: {
                            size: "small",
                            filterable: "",
                            "show-all-levels": option.showAllLevels,
                            props: {
                              checkStrictly: option.props.checkStrictly,
                              multiple: option.props.multiple,
                              value: option.props.value
                                ? option.props.value
                                : "ID",
                              children: option.props.children
                                ? option.props.children
                                : "children",
                              label: option.props.label
                                ? option.props.label
                                : "label",
                            },
                            options: option.options,
                            placeholder: "全部",
                            clearable: "",
                          },
                          on: { change: _vm.searchSelectFn },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "date"
                      ? _c("el-date-picker", {
                          staticClass: "handle-date",
                          staticStyle: { width: "225px" },
                          attrs: {
                            clearable: "",
                            placeholder: "选择日期",
                            size: "",
                            type: "date",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "daterange"
                      ? _c("el-date-picker", {
                          staticClass: "handle-date",
                          staticStyle: { width: "225px" },
                          attrs: {
                            "default-time": ["00:00:00", "23:59:59"],
                            "end-placeholder": option.endPlaceholder,
                            clearable: option.clearableIcon,
                            "range-separator": "-",
                            size: "",
                            "start-placeholder": option.startPlaceholder,
                            type: "daterange",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": option.pickerOptions,
                          },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "datetimerange"
                      ? _c("el-date-picker", {
                          staticClass: "handle-date",
                          staticStyle: { width: "360px" },
                          attrs: {
                            "default-time": ["00:00:00", "23:59:59"],
                            "end-placeholder": option.endPlaceholder,
                            clearable: "",
                            "range-separator": "-",
                            size: "",
                            "start-placeholder": option.startPlaceholder,
                            type: "datetimerange",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.type === "input"
                      ? _c("el-input", {
                          staticClass: "handle-input",
                          staticStyle: { width: "225px" },
                          attrs: {
                            clearable: "",
                            maxlength: option.maxlength,
                            placeholder: option.placeholder,
                            size: "",
                          },
                          on: {
                            clear: _vm.handleSearch,
                            change: _vm.handleSearch,
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.handleSearch.apply(null, arguments)
                            },
                          },
                          model: {
                            value: option.value,
                            callback: function ($$v) {
                              _vm.$set(option, "value", $$v)
                            },
                            expression: "option.value",
                          },
                        })
                      : _vm._e(),
                    option.rightText
                      ? _c("span", { staticClass: "ml5" }, [
                          _vm._v(_vm._s(option.rightText)),
                        ])
                      : _vm._e(),
                    option.type === "inputRange"
                      ? _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "handle-input mr5",
                                staticStyle: { width: "140px" },
                                attrs: {
                                  clearable: "",
                                  maxlength: option.maxlength,
                                  size: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.checkInputMax(
                                      option.value1,
                                      option.value2,
                                      "1",
                                      $event
                                    )
                                  },
                                  clear: _vm.handleSearch,
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    option.value1 = _vm.checkInputNum(
                                      $event,
                                      ">zero"
                                    )
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.handleSearch.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: option.value1,
                                  callback: function ($$v) {
                                    _vm.$set(option, "value1", $$v)
                                  },
                                  expression: "option.value1",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v(_vm._s(option.append)),
                                ]),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "mr5" }, [_vm._v("~")]),
                            _c(
                              "el-input",
                              {
                                staticClass: "handle-input mr5",
                                staticStyle: { width: "140px" },
                                attrs: {
                                  clearable: "",
                                  maxlength: option.maxlength,
                                  size: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.checkInputMax(
                                      option.value1,
                                      option.value2,
                                      "2",
                                      $event
                                    )
                                  },
                                  clear: _vm.handleSearch,
                                },
                                nativeOn: {
                                  input: function ($event) {
                                    option.value2 = _vm.checkInputNum(
                                      $event,
                                      ">zero"
                                    )
                                  },
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.handleSearch.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: option.value2,
                                  callback: function ($$v) {
                                    _vm.$set(option, "value2", $$v)
                                  },
                                  expression: "option.value2",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v(_vm._s(option.append)),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    option.type === "sup"
                      ? _c(
                          "div",
                          [
                            _c("el-input", {
                              staticStyle: { width: "225px" },
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: {
                                focus: _vm.showSelectSupplier,
                                clear: _vm.hideSelectSupplier,
                              },
                              model: {
                                value: option.value,
                                callback: function ($$v) {
                                  _vm.$set(option, "value", $$v)
                                },
                                expression: "option.value",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    option.type === "textKey"
                      ? _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "select-left",
                                staticStyle: { width: "160px" },
                                attrs: { placeholder: "请选择", size: "" },
                                on: {
                                  change: (val) =>
                                    _vm.pulldownWrite(_vm.value, option.value),
                                },
                                model: {
                                  value: option.value,
                                  callback: function ($$v) {
                                    _vm.$set(option, "value", $$v)
                                  },
                                  expression: "option.value",
                                },
                              },
                              _vm._l(option.options, function (selectOption) {
                                return _c("el-option", {
                                  key: selectOption.id,
                                  attrs: {
                                    label: selectOption.label,
                                    value: selectOption.id,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._l(option.searchData, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: { "margin-top": "-1px" },
                                },
                                [
                                  index == option.value
                                    ? _c("el-input", {
                                        staticClass: "select-right",
                                        staticStyle: { width: "215px" },
                                        attrs: {
                                          clearable: "",
                                          maxlength: "9999",
                                          placeholder: item.placeholder,
                                          size: "",
                                        },
                                        on: { clear: _vm.textKeyClearInput },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.handleSearch.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.textKeyValue,
                                          callback: function ($$v) {
                                            _vm.textKeyValue =
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                          },
                                          expression: "textKeyValue",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    option.type === "timeType"
                      ? _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "select-left",
                                staticStyle: { width: "135px" },
                                attrs: { placeholder: "请选择", size: "" },
                                on: {
                                  change: (val) =>
                                    _vm.pulldownWrite2(_vm.value, option.value),
                                },
                                model: {
                                  value: option.value,
                                  callback: function ($$v) {
                                    _vm.$set(option, "value", $$v)
                                  },
                                  expression: "option.value",
                                },
                              },
                              _vm._l(option.options, function (selectOption) {
                                return _c("el-option", {
                                  key: selectOption.id,
                                  attrs: {
                                    label: selectOption.label,
                                    value: selectOption.id,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._l(option.searchData, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: { "margin-top": "-1px" },
                                },
                                [
                                  index == option.value
                                    ? _c("el-date-picker", {
                                        staticClass: "handle-date",
                                        staticStyle: { width: "360px" },
                                        attrs: {
                                          clearable: "",
                                          "default-time": [
                                            "00:00:00",
                                            "23:59:59",
                                          ],
                                          "range-separator": "-",
                                          size: "",
                                          type: "datetimerange",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                        },
                                        on: { change: _vm.handleSearch },
                                        model: {
                                          value: item.value,
                                          callback: function ($$v) {
                                            _vm.$set(item, "value", $$v)
                                          },
                                          expression: "item.value",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm.table.searchOptions.length > 0
            ? _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "search-reset-s",
                      attrs: {
                        icon: "el-icon-search",
                        size: "",
                        type: "primary",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v(" 查 询 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-refresh-left",
                        size: "",
                        disabled: _vm.loading,
                      },
                      on: { click: _vm.clearSearch },
                    },
                    [_vm._v(" 重 置 ")]
                  ),
                  _vm.table.searchOptions.length > 9
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.handleFold },
                        },
                        [
                          _vm.fold
                            ? _c("span", [_vm._v("展开")])
                            : _c("span", [_vm._v("收起")]),
                          _c("vab-icon", {
                            staticClass: "vab-dropdown",
                            class: { "vab-dropdown-active": _vm.fold },
                            attrs: { icon: "arrow-up-s-line" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "bottom-content" },
        [
          _c("div", { staticClass: "tab-more" }, [
            _vm.table.showMoreBtns
              ? _c(
                  "div",
                  { staticClass: "mb10" },
                  [
                    _vm.table.moreBtns.length > 0
                      ? _c("span", { staticClass: "button-title" }, [
                          _vm._v(" 快捷操作 "),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.table.moreBtns, function (moreItem) {
                      return _vm.checkPermi([moreItem.hasPermi])
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "preventReClick",
                                  rawName: "v-preventReClick",
                                },
                              ],
                              key: moreItem.fn,
                              attrs: {
                                icon: moreItem.icon,
                                plain: moreItem.plain,
                                size: "small",
                                type: moreItem.type,
                                disabled: moreItem.disabled,
                                loading: moreItem.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moreOperation(moreItem.fn)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(moreItem.text) + " ")]
                          )
                        : _vm._e()
                    }),
                    _vm.table.redPacketPrice
                      ? _c("span", { staticClass: "ml20" }, [
                          _vm._v(
                            " 红包总额：" +
                              _vm._s(_vm.table.redPacketPrice) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.table.arrBtn && _vm.table.arrBtn.length > 0
                      ? _c(
                          "el-dropdown",
                          {
                            staticClass: "ml10",
                            attrs: { size: "small" },
                            on: { command: _vm.handleCommand },
                          },
                          [
                            _c("el-button", { attrs: { type: "primary" } }, [
                              _vm._v(" 更多 "),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              _vm._l(_vm.table.arrBtn, function (item, index) {
                                return _vm.checkPermi([item.hasPermi])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "preventReClick",
                                            rawName: "v-preventReClick",
                                          },
                                        ],
                                        key: index,
                                        attrs: {
                                          disabled: item.disabled,
                                          command: item.fn,
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(item.text) + " ")]
                                    )
                                  : _vm._e()
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.table.updateTime
                      ? _c(
                          "span",
                          {
                            staticClass: "ml20 text-muted",
                            staticStyle: { "font-size": "12px" },
                          },
                          [
                            _vm._v(
                              " 更新时间：" + _vm._s(_vm.table.updateTime) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.table.leftText
                      ? _c(
                          "span",
                          {
                            staticClass: "ml20 text-muted",
                            staticStyle: { "font-size": "12px" },
                          },
                          [_vm._v(" " + _vm._s(_vm.table.leftText) + " ")]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm.table.rightText
              ? _c(
                  "div",
                  {
                    staticClass: "flex-x mr10 mb10",
                    staticStyle: { flex: "1", "justify-content": "end" },
                  },
                  [_vm._v(" " + _vm._s(_vm.table.rightText) + " ")]
                )
              : _vm._e(),
            _vm.table.canRefresh
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _vm._l(_vm.table.rightTag, function (item, index) {
                      return _c(
                        "el-tag",
                        { key: index, staticClass: "ml10 mr10" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.name) +
                              " : " +
                              _vm._s(item.value) +
                              " "
                          ),
                        ]
                      )
                    }),
                    _vm.table.rightBtn &&
                    _vm.checkPermi([_vm.table.rightBtn.hasPermi])
                      ? _c(
                          "el-button",
                          {
                            staticClass: "mr20",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.operationFn(
                                  _vm.table.rightBtn,
                                  _vm.table.rightBtn.fn
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.table.rightBtn.text) + " ")]
                        )
                      : _vm._e(),
                    _vm.table.searchOptions
                      ? _c(
                          "el-row",
                          { staticClass: "mb10" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.table.showSearchBar
                                    ? "隐藏搜索"
                                    : "显示搜索",
                                  effect: "dark",
                                  placement: "right",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    circle: "",
                                    icon: "el-icon-search",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleSearch()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: "刷新",
                                  effect: "dark",
                                  placement: "right",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    circle: "",
                                    icon: "el-icon-refresh",
                                    size: "mini",
                                    disabled: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm._initData()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: "显隐列",
                                  effect: "dark",
                                  placement: "right",
                                },
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    circle: "",
                                    icon: "el-icon-menu",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.open = true
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          "append-to-body": "",
                          title: "显示/隐藏",
                          visible: _vm.open,
                          width: "630px",
                          "close-on-click-modal": false,
                        },
                        on: {
                          "update:visible": function ($event) {
                            _vm.open = $event
                          },
                        },
                      },
                      [
                        _c("el-transfer", {
                          attrs: {
                            data: _vm.table.options,
                            titles: ["显示", "隐藏"],
                          },
                          on: { change: _vm.dataChange },
                          model: {
                            value: _vm.value,
                            callback: function ($$v) {
                              _vm.value = $$v
                            },
                            expression: "value",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticClass: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-background": "rgba(0, 0, 0, 0.4)",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-text": "拼命加载中",
                "row-style": _vm.rowstyle,
                border: _vm.table.border,
                "summary-method": _vm.getSummaries,
                "show-summary": _vm.table.summary,
                "highlight-current-row": _vm.table.currentRow,
              },
              on: {
                "row-dblclick": _vm.handleSelect,
                "selection-change": _vm.handleSelectionChange,
                "sort-change": _vm.sortChange,
                "current-change": _vm.handleCurrentChange,
                select: _vm.handleSelect,
                "row-click": _vm.handleRowClick,
              },
            },
            [
              _vm.table.radio
                ? _c(
                    "el-table-column",
                    {
                      attrs: { width: "55" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-single-radio" },
                                  [
                                    scope.row.contractId
                                      ? _c("el-radio", {
                                          staticStyle: {
                                            color: "#fff",
                                            "padding-left": "12px",
                                            "margin-right": "-25px",
                                          },
                                          attrs: {
                                            label: scope.row.contractId,
                                          },
                                          model: {
                                            value: _vm.tabelradio,
                                            callback: function ($$v) {
                                              _vm.tabelradio = $$v
                                            },
                                            expression: "tabelradio",
                                          },
                                        })
                                      : _c("el-radio", {
                                          staticStyle: {
                                            color: "#fff",
                                            "padding-left": "12px",
                                            "margin-right": "-25px",
                                          },
                                          attrs: {
                                            label: scope.row.customerId,
                                          },
                                          nativeOn: {
                                            change: function ($event) {
                                              return _vm.getCurrentRow(
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.tabelradio,
                                            callback: function ($$v) {
                                              _vm.tabelradio = $$v
                                            },
                                            expression: "tabelradio",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3270524742
                      ),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("单选"),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.table.selection
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      selectable: _vm.selectable,
                      type: "selection",
                      width: "55",
                    },
                  })
                : _vm._e(),
              _vm._l(_vm.table.options, function (option) {
                return option.key && option.visible
                  ? _c(
                      "el-table-column",
                      {
                        key: option.key,
                        attrs: {
                          align: option.align,
                          fixed: option.fixed,
                          label: option.label,
                          "default-sort": {
                            prop: "createTime",
                            order: "descending",
                          },
                          "min-width": option.minWidth,
                          prop: option.key,
                          "show-overflow-tooltip": option.tooltip,
                          sortable: option.sort ? option.key : false,
                          width: option.width,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  option.type === "self"
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          scope.row[option.key],
                                          function (opItem) {
                                            return _c(
                                              "div",
                                              { key: opItem.key },
                                              [
                                                opItem.html &&
                                                opItem.type === "txt"
                                                  ? _c("div", {
                                                      staticClass: "row-txt",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          opItem.html
                                                        ),
                                                      },
                                                      on: {
                                                        click: (event) => {
                                                          _vm.htmlClick(
                                                            event,
                                                            opItem.click
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                !opItem.html &&
                                                opItem.type === "txt"
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass: "row-txt",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              opItem.content
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                opItem.type === "btns"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "10px",
                                                        },
                                                      },
                                                      [
                                                        _vm._l(
                                                          opItem.content,
                                                          function (bItem) {
                                                            return bItem.icon &&
                                                              bItem.icon ==
                                                                "eye"
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    key: bItem.key,
                                                                    staticClass:
                                                                      "eye",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.columnBtns(
                                                                            scope,
                                                                            bItem.fn
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i"),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          bItem.label
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        _vm._l(
                                                          opItem.content,
                                                          function (bItem) {
                                                            return !bItem.icon
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    key: bItem.key,
                                                                    attrs: {
                                                                      size: "mini",
                                                                      type: "primary",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.columnBtns(
                                                                            scope,
                                                                            bItem.fn
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          bItem.label
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : option.type === "status"
                                    ? _c("div", [
                                        option.overflow &&
                                        scope.row[option.key] &&
                                        scope.row[option.key].length >
                                          option.overflow
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      content: _vm.isShowState(
                                                        option,
                                                        scope
                                                      ),
                                                      effect: "dark",
                                                      placement: "top-end",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          overflow: "hidden",
                                                          "white-space":
                                                            "nowrap",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          cursor: "pointer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.isShowState(
                                                                option,
                                                                scope
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _vm.isStateflag(option, scope)
                                                  ? _c("span", {
                                                      staticClass: "origin",
                                                      style: {
                                                        background:
                                                          _vm.isStateflag(
                                                            option,
                                                            scope
                                                          ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "line-height": "40px",
                                                      overflow: "hidden",
                                                      "white-space": "nowrap",
                                                      "text-overflow":
                                                        "ellipsis",
                                                    },
                                                    style: {
                                                      color: _vm.isStateColor(
                                                        option,
                                                        scope
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    option.showRedText &&
                                                    scope.row.noticeStatus == 2
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.isShowState(
                                                                    option,
                                                                    scope
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.isShowState(
                                                                option,
                                                                scope
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                    option.tooltipText &&
                                                    scope.row.payStatus == 2 &&
                                                    scope.row.reviewerStatus !=
                                                      2
                                                      ? _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              content:
                                                                scope.row
                                                                  .failReason,
                                                              effect: "light",
                                                              placement:
                                                                "right",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-warning",
                                                              staticStyle: {
                                                                color: "red",
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                scope.row.memberState == 2 &&
                                                option.tooltipText
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        staticClass: "item",
                                                        attrs: {
                                                          content: "",
                                                          effect: "light",
                                                          placement: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          [
                                                            scope.row.state == 5
                                                              ? _c("div", [
                                                                  _vm._v(
                                                                    " 当前用户在" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .quitTime
                                                                      ) +
                                                                      "被队长移除队伍； 若任务完成，则按业绩贡献率发放奖励 "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            scope.row.state == 4
                                                              ? _c("div", [
                                                                  _vm._v(
                                                                    " 当前用户在" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .quitTime
                                                                      ) +
                                                                      "被取消分享官身份； 若任务完成，则按业绩贡献率发放奖励 "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            scope.row.state == 2
                                                              ? _c("div", [
                                                                  _vm._v(
                                                                    " 当前用户在" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .quitTime
                                                                      ) +
                                                                      "自主退出队伍； 若任务完成，则奖励自动归队长所有 "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-question realpointer",
                                                          staticStyle: {
                                                            cursor: "pointer",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                      ])
                                    : option.type === "input"
                                    ? _c("div", [
                                        !scope.row.edit
                                          ? _c(
                                              "div",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEdit(scope)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row[option.key]
                                                    ) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass: "el-icon-edit",
                                                }),
                                              ]
                                            )
                                          : _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: scope.row[option.key],
                                                  expression:
                                                    "scope.row[option.key]",
                                                },
                                              ],
                                              ref: "input" + scope.row.taskCode,
                                              refInFor: true,
                                              staticClass: "el-input__inner",
                                              attrs: {
                                                autofocus: "",
                                                type: "text",
                                              },
                                              domProps: {
                                                value: scope.row[option.key],
                                              },
                                              on: {
                                                blur: function ($event) {
                                                  return _vm.handleEditSubmit(
                                                    scope,
                                                    option.fn
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    scope.row,
                                                    option.key,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                      ])
                                    : option.type === "CommissionDesc"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          scope.row["scheduledStatus"] == 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          option.key ==
                                                          "firstCommissionDesc"
                                                            ? "将于" +
                                                              scope.row[
                                                                "scheduledBeginTime"
                                                              ] +
                                                              " 佣金奖励变更为" +
                                                              scope.row[
                                                                "scheduledRateFirst"
                                                              ] +
                                                              "%"
                                                            : "将于" +
                                                              scope.row[
                                                                "scheduledBeginTime"
                                                              ] +
                                                              " 佣金奖励变更为" +
                                                              scope.row[
                                                                "scheduledRateSecond"
                                                              ] +
                                                              "%",
                                                        effect: "dark",
                                                        placement: "top-end",
                                                      },
                                                    },
                                                    [
                                                      scope.row[option.key]
                                                        ? _c("div", {
                                                            staticClass:
                                                              "el-icon-alarm-clock ml5 mr5",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row[option.key]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _c("div", {
                                                    staticStyle: {
                                                      width: "25px",
                                                      height: "1px",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[option.key]
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      )
                                    : option.type === "userInfo"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goodImg mr10" },
                                            [
                                              scope.row.customerAvatar
                                                ? _c("el-image", {
                                                    staticClass:
                                                      "imgs vipavator",
                                                    staticStyle: {
                                                      width: "40px",
                                                      height: "40px",
                                                    },
                                                    attrs: {
                                                      src: scope.row
                                                        .customerAvatar,
                                                      "preview-src-list": [
                                                        scope.row
                                                          .customerAvatar,
                                                      ],
                                                    },
                                                  })
                                                : _c("el-image", {
                                                    staticClass: "vipavator",
                                                    staticStyle: {
                                                      width: "40px",
                                                      height: "40px",
                                                    },
                                                    attrs: {
                                                      src: "https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png",
                                                      "preview-src-list": [
                                                        "https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png",
                                                      ],
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(scope.row.customerName)
                                                ),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.customerPhone
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : option.type === "goodInfo"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goodImg mr10" },
                                            [
                                              _c("el-image", {
                                                staticClass: "imgs",
                                                staticStyle: {
                                                  width: "40px",
                                                  height: "40px",
                                                },
                                                attrs: {
                                                  "preview-src-list": [
                                                    scope.row.goodsGallery.split(
                                                      ","
                                                    )[0],
                                                  ],
                                                  src: scope.row.goodsGallery.split(
                                                    ","
                                                  )[0],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          option.goodsType
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "mr5",
                                                      attrs: {
                                                        size: "mini",
                                                        type: "danger",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option.goodsType
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ml5",
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        placement: "right",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            slot: "content",
                                                          },
                                                          slot: "content",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .goodsName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "200px",
                                                            overflow: "hidden",
                                                            "white-space":
                                                              "nowrap",
                                                            "text-overflow":
                                                              "ellipsis",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .goodsName
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(scope.row.goodsSn)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : option.type === "goodInfo2"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goodImg mr10" },
                                            [
                                              _c("el-image", {
                                                staticClass: "imgs",
                                                staticStyle: {
                                                  width: "40px",
                                                  height: "40px",
                                                },
                                                attrs: {
                                                  "preview-src-list": [
                                                    scope.row.goodsGallery.split(
                                                      ","
                                                    )[0],
                                                  ],
                                                  src: scope.row.goodsGallery.split(
                                                    ","
                                                  )[0],
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          option.goodsType
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "mr5",
                                                      attrs: {
                                                        size: "mini",
                                                        type: "danger",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            option.goodsType
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ml5",
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        placement: "right",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "left",
                                                          },
                                                          attrs: {
                                                            slot: "content",
                                                          },
                                                          slot: "content",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .goodsName
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "130px",
                                                            "text-align":
                                                              "left",
                                                            overflow: "hidden",
                                                            "white-space":
                                                              "nowrap",
                                                            "text-overflow":
                                                              "ellipsis",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .goodsName
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              scope.row.minPrice !=
                                              scope.row.maxPrice
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ￥" +
                                                          _vm._s(
                                                            scope.row.minPrice
                                                          ) +
                                                          "~￥" +
                                                          _vm._s(
                                                            scope.row.maxPrice
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ￥" +
                                                          _vm._s(
                                                            scope.row.minPrice
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : option.type === "customerInfo"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goodImg mr10" },
                                            [
                                              _c("el-image", {
                                                staticClass: "imgs",
                                                staticStyle: {
                                                  width: "40px",
                                                  height: "40px",
                                                },
                                                attrs: {
                                                  "preview-src-list": [
                                                    scope.row.customerAvatar
                                                      ? scope.row.customerAvatar
                                                      : "https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png",
                                                  ],
                                                  src: scope.row.customerAvatar
                                                    ? scope.row.customerAvatar
                                                    : "https://mall.alicdn.girdeargroup.com/admin/pms/media/images/49a20d34-c38b-475a-8f17-e60466b747fd.png",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.customerName
                                                        ? scope.row.customerName
                                                        : "-"
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.customerPhone
                                                        ? scope.row
                                                            .customerPhone
                                                        : "-"
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    : option.type === "supplierSkuSettles"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "text-align": "center",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.divideByHundred(
                                                  scope.row[option.key]
                                                )
                                              )
                                            ),
                                          ]),
                                          scope.row["settleList"]
                                            ? _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "top-start",
                                                    trigger: "hover",
                                                    width: "350",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-table",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        data: scope.row[
                                                          "settleList"
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          label: "特定结算时间",
                                                          width: "200",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                scope
                                                              ) {
                                                                return [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        new Date(
                                                                          scope.row.beginTime
                                                                        ).Format(
                                                                          "yyyy-MM-dd"
                                                                        )
                                                                      ) +
                                                                      " 至 " +
                                                                      _vm._s(
                                                                        new Date(
                                                                          scope.row.endTime
                                                                        ).Format(
                                                                          "yyyy-MM-dd"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          align: "center",
                                                          label: "特定结算价",
                                                          width: "120",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                scope
                                                              ) {
                                                                return [
                                                                  _vm._v(
                                                                    " ￥" +
                                                                      _vm._s(
                                                                        _vm.divideByHundred(
                                                                          scope
                                                                            .row
                                                                            .skuSettlePrice
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "ml5 el-icon-time",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    attrs: {
                                                      slot: "reference",
                                                    },
                                                    slot: "reference",
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : option.type === "switch"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              "active-value": 1,
                                              "inactive-value": 0,
                                              disabled:
                                                _vm.isDisabled(option, scope) ||
                                                !_vm.checkPermi([
                                                  option.hasPermi,
                                                ]),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.operationFn(
                                                  scope,
                                                  option.fn
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row[option.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  option.key,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row[option.key]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : option.type === "edit"
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "table-hover-btn" },
                                          [
                                            _vm.checkPermi([option.hasPermi]) &&
                                            _vm.isStatus(option, scope)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-hover-btn-box",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.operationFn(
                                                          scope,
                                                          option.fn
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.couponNumber
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-edit",
                                                      staticStyle: {
                                                        width: "40px",
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-hover-btn-box",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          !!scope.row[
                                                            option.key
                                                          ] ||
                                                            scope.row[
                                                              option.key
                                                            ] === 0
                                                            ? scope.row[
                                                                option.key
                                                              ]
                                                            : "—"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ])
                                    : option.type === "img"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                            },
                                            attrs: {
                                              fit: "scale-down",
                                              "preview-src-list": [
                                                scope.row[option.key],
                                              ],
                                              src: scope.row[option.key],
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : option.type === "imgs"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-image", {
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                            },
                                            attrs: {
                                              fit: "scale-down",
                                              "preview-src-list":
                                                scope.row[option.key],
                                              src: scope.row[option.key][0],
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : option.type === "dict"
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.dictFn(
                                                option,
                                                scope.row[option.key]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : option.type === "supplierName"
                                    ? _c("div", [
                                        _vm.checkPermi([option.hasPermi])
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "table-hover-btn",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "table-hover-btn-box",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.operationFn(
                                                          scope,
                                                          option.fn
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("vab-icon", {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      style: {
                                                        color: "#1890ff",
                                                      },
                                                      attrs: {
                                                        icon: "attachment-2",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.operationFn(
                                                            scope,
                                                            option.fn
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row[option.key]
                                                        ) +
                                                        " "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row[option.key]
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ])
                                    : option.type === "name"
                                    ? _c("div", [
                                        option.overflow &&
                                        scope.row[option.key] &&
                                        scope.row[option.key].length >
                                          option.overflow
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      content:
                                                        scope.row[option.key],
                                                      effect: "dark",
                                                      placement: "top-end",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          overflow: "hidden",
                                                          "white-space":
                                                            "nowrap",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleCopy(
                                                              scope.row[
                                                                option.key
                                                              ],
                                                              option.label
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row[
                                                                option.key
                                                              ]
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : option.copy
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCopy(
                                                      scope.row[option.key],
                                                      option.label
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !!scope.row[option.key] ||
                                                        scope.row[
                                                          option.key
                                                        ] === 0
                                                        ? scope.row[option.key]
                                                        : "—"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !!scope.row[option.key] ||
                                                      scope.row[option.key] ===
                                                        0
                                                      ? scope.row[option.key]
                                                      : "—"
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ])
                                    : option.type === "btn"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          option.text &&
                                          (!!scope.row[option.key] ||
                                            scope.row[option.key] === 0)
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "50px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.text) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          option.multiple
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          scope.row[option.key],
                                                        placement: "top-start",
                                                      },
                                                    },
                                                    [
                                                      !!scope.row[option.key] ||
                                                      scope.row[option.key] ===
                                                        0
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              staticStyle: {
                                                                flex: "1",
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.operationFn(
                                                                      scope,
                                                                      option.fn
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    scope.row[
                                                                      option.key
                                                                    ]
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  !!scope.row[option.key] ||
                                                  scope.row[option.key] === 0
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.operationFn(
                                                                scope,
                                                                option.fn
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row[
                                                                  option.key
                                                                ]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                        ]
                                      )
                                    : option.type === "btnxp"
                                    ? _c(
                                        "div",
                                        { staticClass: "flex-x btnxp" },
                                        [
                                          _c("div", { staticClass: "flex-y" }, [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.relatedGoodsName
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(scope.row.relatedGoodsSn)
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "btnxpbtn ml10",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.operationFn(
                                                    scope,
                                                    option.fn
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : option.type === "btnGift"
                                    ? _c("div", [
                                        scope.row.goodsSkuSpecs &&
                                        _vm.checkPermi([option.hasPermi])
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-x btnGift-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.operationFn(
                                                      scope,
                                                      option.fn
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        JSON.parse(
                                                          scope.row
                                                            .goodsSkuSpecs
                                                        ).join("/")
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", {}, [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "btnGift-btn-box",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-edit",
                                                        staticStyle: {
                                                          width: "40px",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.operationFn(
                                                          scope,
                                                          option.fn
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 选择规格 ")]
                                                ),
                                              ],
                                              1
                                            ),
                                      ])
                                    : option.type === "customerLevel"
                                    ? _c(
                                        "div",
                                        [
                                          scope.row.ruleCount == null
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.operationFn(
                                                        scope,
                                                        option.fn
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 选择权益 ")]
                                              )
                                            : _c(
                                                "div",
                                                {},
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "已选" +
                                                        _vm._s(
                                                          scope.row[option.key]
                                                        ) +
                                                        "项"
                                                    ),
                                                  ]),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticClass: "ml50",
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.operationFn(
                                                            scope,
                                                            option.fn
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 修改 ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                        ],
                                        1
                                      )
                                    : option.type === "operation"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex-x",
                                          staticStyle: {
                                            "justify-content": "left",
                                          },
                                        },
                                        _vm._l(
                                          option.operation,
                                          function (btn_item) {
                                            return _c(
                                              "span",
                                              { key: btn_item.text },
                                              [
                                                _vm.isShowBtn(
                                                  btn_item,
                                                  scope
                                                ) &&
                                                _vm.checkPermi([
                                                  btn_item.hasPermi,
                                                ])
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "preventReClick",
                                                            rawName:
                                                              "v-preventReClick",
                                                          },
                                                        ],
                                                        staticClass: "mr10",
                                                        class: {
                                                          "text-danger":
                                                            btn_item.danger,
                                                        },
                                                        staticStyle: {
                                                          "margin-left": "0",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            btn_item.disabled,
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.operationFn(
                                                              scope,
                                                              btn_item.fn
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.isShowBtn(
                                                                btn_item,
                                                                scope
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                btn_item.type == "btn" &&
                                                scope.row.removeCauseList &&
                                                scope.row.removeCauseList
                                                  .length > 0
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: { type: "text" },
                                                      },
                                                      [
                                                        _c(
                                                          "el-tooltip",
                                                          {
                                                            attrs: {
                                                              effect: "light",
                                                              placement:
                                                                "right",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  slot: "content",
                                                                },
                                                                slot: "content",
                                                              },
                                                              _vm._l(
                                                                scope.row
                                                                  .removeCauseList,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: index,
                                                                      staticClass:
                                                                        "mb5",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            scope.row
                                                              .activityState !=
                                                            3
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "preventReClick",
                                                                          rawName:
                                                                            "v-preventReClick",
                                                                        },
                                                                      ],
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.operationFn(
                                                                            scope,
                                                                            btn_item.fn
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " 删除 "
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-warning",
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "red",
                                                                          cursor:
                                                                            "pointer",
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                btn_item.type == "btn2" &&
                                                scope.row.removeCauseList &&
                                                scope.row.removeCauseList
                                                  .length > 0
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          effect: "light",
                                                          placement: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          _vm._l(
                                                            scope.row
                                                              .removeCauseList,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "mb5",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        scope.row
                                                          .activityState != 3
                                                          ? _c(
                                                              "div",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "preventReClick",
                                                                    rawName:
                                                                      "v-preventReClick",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "mt5",
                                                                staticStyle: {
                                                                  width: "50px",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.operationFn(
                                                                        scope,
                                                                        btn_item.fn
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-warning",
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                    cursor:
                                                                      "pointer",
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                btn_item.type == "btn3" &&
                                                scope.row.removeCauseList &&
                                                scope.row.removeCauseList
                                                  .length > 0
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          effect: "light",
                                                          placement:
                                                            "left-start",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          _vm._l(
                                                            scope.row
                                                              .removeCauseList,
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "mb5",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt5",
                                                            staticStyle: {
                                                              width: "50px",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-warning",
                                                              staticStyle: {
                                                                color: "red",
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                btn_item.type == "btn" &&
                                                scope.row.msgStatus == 0 &&
                                                new Date(scope.row.sendTime) <
                                                  new Date()
                                                  ? _c(
                                                      "el-tooltip",
                                                      {
                                                        attrs: {
                                                          effect: "light",
                                                          placement: "right",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            slot: "content",
                                                          },
                                                          [
                                                            scope.row
                                                              .templateStatus ==
                                                            3
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          "模板审核未通过：模板审核不通过，请至模板列表查看原因"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            scope.row
                                                              .templateStatus ==
                                                            1
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          "模板还在审核中：模板审核中，审核通过后，将自动给客户发送短信"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            scope.row
                                                              .templateStatus ==
                                                            0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          "模板还在审核中：模板审核中，审核通过后，将自动给客户发送短信"
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            scope.row
                                                              .templateStatus ==
                                                            2
                                                              ? _c("div", {
                                                                  staticClass:
                                                                    "mb5",
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        scope.row
                                                          .templateStatus != 2
                                                          ? _c("i", {
                                                              staticClass:
                                                                "el-icon-warning",
                                                              staticStyle: {
                                                                color: "red",
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              !!scope.row[option.key] ||
                                                scope.row[option.key] === 0
                                                ? scope.row[option.key]
                                                : "—"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        option.header
                          ? _c(
                              "template",
                              { slot: "header" },
                              [
                                _c("span", [_vm._v(_vm._s(option.label))]),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      content: "",
                                      effect: "light",
                                      placement: "right",
                                    },
                                  },
                                  [
                                    _c("div", {
                                      attrs: { slot: "content" },
                                      domProps: {
                                        innerHTML: _vm._s(option.header),
                                      },
                                      slot: "content",
                                    }),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-question realpointer",
                                      staticStyle: { cursor: "pointer" },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
          _c(
            "el-row",
            {
              staticClass: "pagination mt10",
              attrs: { justify: "space-between", type: "flex" },
            },
            [
              _c("el-col", { staticClass: "btn-group", attrs: { span: 8 } }, [
                _vm.table.tableTip
                  ? _c(
                      "div",
                      {
                        staticClass: "mt20",
                        style: {
                          color: _vm.table.tableTip.color,
                          fontSize: "14px",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.table.tableTip.text) + " ")]
                    )
                  : _vm._e(),
              ]),
              !_vm.table.noPage && _vm.paginationShow
                ? _c("el-pagination", {
                    staticClass: "mt10",
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "page-sizes": [10, 20, 30, 50, 100],
                      "current-page": _vm.params.pageNum,
                      "pager-count": 5,
                      "auto-scroll": false,
                      size: _vm.params.pageSize,
                      total: _vm.total,
                    },
                    on: {
                      "current-change": _vm.handlePageChange,
                      "size-change": _vm.handleSizeChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.table.tableDialog
        ? _c("BaseDialogForm", {
            ref: "dialogForm",
            attrs: {
              config: _vm.table.formConfig,
              "form-data": _vm.table.formModel,
              title: _vm.dialogTitle,
              width: _vm.table.dialogWidth,
            },
            on: { submit: _vm.dialogSubmit },
          })
        : _vm._e(),
      _vm.suppliervisible
        ? _c("selectSupplier", { on: { handleSupplier: _vm.handleSupplier } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }